module.exports = __webpack_public_path__ + "img/bug.f8c0b8d4.svg";